/* mm-produkt.js — Magic Milk
 *
 * Produktseiten-Galerie nach Merts Vorlage von morenutrition.de (15.08.2026):
 * grosses Bild mit runden Ecken, waagerecht wischbar, darunter eine dünne
 * Fortschrittslinie statt Punkten oder Vorschaubildern — plus Zähler "1 / 6".
 *
 * Die Galerie selbst wird NICHT nachgebaut. Das Theme bringt eine funktionierende
 * <slideshow-slides> mit Scroll-Snap mit; hier wird nur ausgelesen, wie weit sie
 * gescrollt ist, und daraus die Linie gezeichnet. Damit bleiben Wischen, Zoom,
 * Tastatur und der Wechsel bei Variantenauswahl unverändert erhalten.
 *
 * Die Vorschaubild-Leiste wird ausgeblendet, weil Mert die Linie ausdrücklich
 * "statt Punkte oder so" wollte. Rückgängig: ZEIGE_VORSCHAU auf true.
 */
(function () {
  if (window.location.pathname.indexOf('/products/') !== 0) return;

  var script = document.currentScript;
  var scriptSrc = script && script.src || '';
  var assetBase = scriptSrc ? scriptSrc.slice(0, scriptSrc.lastIndexOf('/') + 1) : '/cdn/shop/assets/';

  var ZEIGE_VORSCHAU = false;
  var K = 'cubic-bezier(.22,.61,.36,1)';
  var DUNKEL = '#151013';
  var RADIUS = '16px';

  /* Der Fortschrittsbalken trägt die Farbe des Produkts (Mert, 16.08.).
     Es sind exakt dieselben Werte wie beim Wechselwort auf der Startseite —
     aus den echten Verpackungsfotos gemessen, nicht geschätzt.
     Reihenfolge zählt: "strawberry" muss VOR "magic milk" geprüft werden,
     sonst bekäme die Erdbeer-Box das Orange der Standard-Box. */
  var FARBEN = [
    [/nuss|zero.?termo|creamy/i,        '#55711C'],   // Packungsgrün ZeroTermo
    [/magic.?fruit|florea/i,            '#D5455D'],   // Pinkrot Magic Fruit
    [/erdbeer|strawberry/i,             '#EA597B'],   // Rosa Strawberry
    [/magic.?milk|for.?x5|standard/i,   '#DF611D']    // FOR-X5-Logo-Orange
  ];

  function produktFarbe() {
    var quelle = decodeURIComponent(window.location.pathname) + ' ' +
      ((document.querySelector('.view-product-title,h1') || {}).textContent || '');
    for (var i = 0; i < FARBEN.length; i++) {
      if (FARBEN[i][0].test(quelle)) return FARBEN[i][1];
    }
    return DUNKEL;                                     // alles andere bleibt dunkel
  }
  var BALKEN = produktFarbe();

  var css = [
    '@font-face{font-family:"MM Bricolage ExtraBold";src:url("' + assetBase +
      'mm-bricolage-extrabold.woff2") format("woff2");font-weight:800;font-style:normal;font-display:swap}',
    /* Runde Ecken wie in der Vorlage.
       ACHTUNG: 'product-media-container' ist eine Klasse AUF dem
       <slideshow-slide>, kein Kind davon. Mit einem Nachfahren-Selektor
       (Leerzeichen) greift die Regel ins Leere — daran ist der erste
       Versuch am 15.08. gescheitert. */
    'html body media-gallery slideshow-slide,',
    'html body media-gallery slideshow-slide.product-media-container,',
    'html body media-gallery slideshow-slide .product-media{',
    'border-radius:' + RADIUS + ';overflow:hidden}',

    /* Nächstes Bild anschneiden, wie in der Vorlage: die Folie ist
       schmaler als das Fenster, dadurch lugt die nächste hervor.
       Der Abstandhalter am Ende sorgt dafür, dass auch die letzte Folie
       noch links andocken kann. */
    /* Abstand MUSS gleich dem Polster sein. Ist er kleiner, bleibt vom
       vorherigen Bild ein Streifen stehen (Polster minus Abstand) — bei
       12/10 waren das 2 px rote Kante. Bei 12/12 sind es null. */
    'html body media-gallery slideshow-slides{gap:12px;',
    /* Polster links und rechts — ohne das klebt das Bild am Seitenrand
       und der Anschnitt sieht nach Fehler aus statt nach Absicht.
       scroll-padding sorgt dafür, dass beim Wischen auf 16px eingerastet
       wird und nicht auf 0. */
    'padding-left:12px!important;padding-right:12px!important;',
    'scroll-padding-left:12px!important}',
    /* 26 statt 46: der Anschnitt des nächsten Bildes geht von ~62 px
       auf ~28 px zurück (Mert 15.08.: "bisschen zu viel gezeigt"). */
    'html body media-gallery slideshow-slide{flex:0 0 calc(100% - 26px)!important;',
    'width:calc(100% - 26px)!important;max-width:none!important;',
    'scroll-snap-align:start!important}',
    /* Weisse Blende über dem linken Polster. Im Ruhezustand reicht schon
       Punkt 1, aber WÄHREND des Wischens schiebt sich das vorherige Bild
       sonst sichtbar durch den Rand — genau das war auf Merts Bild zu sehen.
       Nur am Handy: auf dem Desktop liegen dort die Pfeile des Themes. */
    '@media(max-width:899px){',
    'html body media-gallery slideshow-container{position:relative}',
    'html body media-gallery slideshow-container::before{content:"";',
    'position:absolute;left:0;top:0;bottom:0;width:12px;background:#fff;',
    'z-index:3;pointer-events:none}}',

    /* Die Fortschrittslinie auf dieselbe Flucht bringen */
    'html body .mmPfLeiste{padding-left:12px;padding-right:12px}',

    /* Infoblock blendet beim Hereinscrollen gestaffelt auf — dieselbe
       Handschrift wie die Überschriften auf der Startseite. */
    'html body .mmPfAuf{opacity:0;transform:translateY(14px);filter:blur(6px);',
    'transition:opacity .5s ' + K + ',transform .5s ' + K + ',filter .5s ' + K + '}',
    'html body .mmPfAuf.da{opacity:1;transform:none;filter:blur(0)}',
    '@media (prefers-reduced-motion:reduce){',
    'html body .mmPfAuf{opacity:1!important;transform:none!important;filter:none!important}}',

    /* Produkttitel: Magic-Milk-Markenfont statt der schmalen Barlow-Fassung. */
    'html body #MainContent [data-testid="product-information-details"] ',
    '.section-store--product-info-wrapper--container>.text-block.h2,',
    'html body #MainContent [data-testid="product-information-details"] ',
    '.section-store--product-info-wrapper--container>.text-block.h2>p{',
    'font-family:"MM Bricolage ExtraBold","Bricolage Grotesque","Manrope",system-ui,sans-serif!important;',
    'font-size:clamp(1.82rem,8vw,2.45rem)!important;font-weight:800!important;',
    'line-height:.98!important;letter-spacing:-.035em!important;',
    'text-transform:uppercase!important;text-wrap:balance!important}',
    'html body #MainContent [data-testid="product-information-details"] ',
    '.section-store--product-info-wrapper--container>.text-block.h2{',
    'width:100%!important;max-width:100%!important}',

    /* Auf kleinen Displays etwas offener gesetzt: dieselbe echte Markenschrift,
       aber ohne die gedrungene, fast zusammengeklebte Wirkung. */
    '@media(max-width:699px){',
    'html body #MainContent [data-testid="product-information-details"] ',
    '.section-store--product-info-wrapper--container>.text-block.h2,',
    'html body #MainContent [data-testid="product-information-details"] ',
    '.section-store--product-info-wrapper--container>.text-block.h2>p{',
    'font-size:clamp(1.78rem,7.6vw,2.2rem)!important;line-height:1.04!important;',
    'letter-spacing:-.024em!important}}',

    /* Bewertungszeile auf dem Handy bewusst eine Stufe kleiner. Der App-Block
       und sein Link bleiben unveraendert; nur Sterne und Text werden kompakter. */
    '@media(max-width:699px){',
    'html body #MainContent .mmPfBewertungKompakt{--sr-fs:10px!important}',
    'html body #MainContent .mmPfBewertungKompakt>a.bbsr{height:12px!important;min-height:12px!important}',
    'html body #MainContent .mmPfBewertungKompakt .bbsr-s{height:12px!important;gap:.5px!important}',
    'html body #MainContent .mmPfBewertungKompakt .bbsr-s svg{width:12px!important;height:12px!important}',
    'html body #MainContent .mmPfBewertungKompakt .bbsr-t{font-size:10px!important;line-height:13px!important}',
    '}',

    /* Fortschrittslinie.
       17.09.2026: seitlich 12 px wie in der Regel oben ("dieselbe Flucht").
       Das "2px" dieser spaeteren Regel hatte sie ueberschrieben - der Zaehler
       stand 2 px vor dem Rand und lief am iPhone aus dem Bild. */
    'html body .mmPfLeiste{display:flex;align-items:center;gap:14px;',
    'padding:12px 12px 2px;width:100%;box-sizing:border-box}',
    'html body .mmPfSpur{position:relative;flex:1 1 auto;height:3px;',
    'background:rgba(21,16,19,.13);border-radius:999px;overflow:hidden}',
    'html body .mmPfBalken{position:absolute;top:0;left:0;height:100%;',
    'background:' + BALKEN + ';border-radius:999px;',
    'transition:transform .18s linear}',
    'html body .mmPfZahl{flex:none;font-size:13px;color:rgba(21,16,19,.55);',
    'font-variant-numeric:tabular-nums;white-space:nowrap}',
    '@media (prefers-reduced-motion:reduce){html body .mmPfBalken{transition:none}}'
  ];

  if (!ZEIGE_VORSCHAU) {
    css.push('html body media-gallery slideshow-controls{display:none!important}');
  }
  css = css.join('');

  function stil() {
    if (document.getElementById('mmProdukt-stil')) return;
    var s = document.createElement('style');
    s.id = 'mmProdukt-stil';
    s.textContent = css;
    (document.head || document.documentElement).appendChild(s);
  }

  function anbinden(folien) {
    if (folien.dataset.mmPf === '1') return;

    var behaelter = folien.closest('slideshow-container') || folien.parentElement;
    if (!behaelter) return;

    var leiste = document.createElement('div');
    leiste.className = 'mmPfLeiste';
    var spur = document.createElement('div');
    spur.className = 'mmPfSpur';
    var balken = document.createElement('div');
    balken.className = 'mmPfBalken';
    var zahl = document.createElement('span');
    zahl.className = 'mmPfZahl';
    spur.appendChild(balken);
    leiste.appendChild(spur);
    leiste.appendChild(zahl);
    behaelter.parentNode.insertBefore(leiste, behaelter.nextSibling);
    folien.dataset.mmPf = '1';

    function zeichnen() {
      var n = folien.children.length;
      if (n < 1) return;
      var weg = folien.scrollWidth - folien.clientWidth;
      var anteil = weg > 0 ? folien.scrollLeft / weg : 0;
      if (anteil < 0) anteil = 0;
      if (anteil > 1) anteil = 1;

      var spurBreite = spur.clientWidth;
      var balkenBreite = Math.max(18, spurBreite / n);
      balken.style.width = balkenBreite + 'px';
      balken.style.transform = 'translateX(' + (anteil * (spurBreite - balkenBreite)) + 'px)';

      // Welche Folie steht gerade? Aus der Scrollposition, nicht geraten.
      var jetzt = n > 1 ? Math.round(anteil * (n - 1)) + 1 : 1;
      var text = jetzt + ' / ' + n;
      if (zahl.textContent !== text) zahl.textContent = text;
    }

    folien.addEventListener('scroll', zeichnen, { passive: true });
    window.addEventListener('resize', zeichnen, { passive: true });
    document.addEventListener('visibilitychange', function () {
      if (!document.hidden) zeichnen();
    });
    // Das Theme tauscht die Folien bei Variantenwechsel aus
    try {
      new MutationObserver(zeichnen).observe(folien, { childList: true });
    } catch (e) {}

    zeichnen();
    setTimeout(zeichnen, 400);
    setTimeout(zeichnen, 1500);
  }

  /* Titel, Bewertung, Spar-Fahne, Preis und Etikett nacheinander einblenden.
     WICHTIG: Das Verstecken passiert erst per JavaScript. Fällt das Skript aus,
     steht alles ganz normal da — ein unsichtbarer Preis darf nie entstehen.
     Zusätzlich macht ein Notnagel nach 5 Sekunden alles sichtbar. */
  function infoblock() {
    if (!('IntersectionObserver' in window)) return;
    var g = document.querySelector('.product-details .group-block-content');
    if (!g || g.dataset.mmAuf === '1') return;
    var teile = [].slice.call(g.children).filter(function (e) {
      return e.getBoundingClientRect().height > 8;
    }).slice(0, 6);
    if (!teile.length) return;
    g.dataset.mmAuf = '1';

    teile.forEach(function (e, i) {
      e.classList.add('mmPfAuf');
      e.style.transitionDelay = (i * 90) + 'ms';
    });

    var beo = new IntersectionObserver(function (eintraege) {
      eintraege.forEach(function (x) {
        if (x.isIntersecting) { x.target.classList.add('da'); beo.unobserve(x.target); }
      });
    }, { threshold: 0.1 });
    teile.forEach(function (e) { beo.observe(e); });

    setTimeout(function () {
      [].forEach.call(document.querySelectorAll('.mmPfAuf:not(.da)'), function (e) {
        e.classList.add('da');
      });
    }, 5000);
  }

  function bewertungKompakt() {
    var text = document.querySelector('#MainContent .bbsr-t');
    var block = text && text.closest('.shopify-app-block');
    if (!block) return false;
    block.classList.add('mmPfBewertungKompakt');
    return true;
  }

  /* Story-Kreise auf Produktseiten ausblenden (Mert 15.08.).
     Die Sektion sitzt in der Kopfgruppe und läuft deshalb auf JEDER Seite
     mit — auf der Startseite bleibt sie, hier ist sie weg. Über JavaScript
     statt fester ID, weil die Sektions-ID beim Neuanlegen wechseln würde. */
  function storyWeg() {
    var k = document.querySelector('.st_story-circle');
    if (!k) return;
    var sek = k.closest('.shopify-section');
    if (sek && sek.style.display !== 'none') sek.style.setProperty('display', 'none', 'important');
  }

  function durchgang() {
    bewertungKompakt();
    var alle = document.querySelectorAll('media-gallery slideshow-slides');
    if (!alle.length) return false;
    stil();
    [].forEach.call(alle, anbinden);
    infoblock();
    storyWeg();
    return true;
  }

  function start() {
    bewertungKompakt();
    setTimeout(bewertungKompakt, 800);
    setTimeout(bewertungKompakt, 2200);
    storyWeg();
    if (!durchgang()) {
      var n = 0;
      var t = setInterval(function () {
        n++;
        if (durchgang() || n > 14) clearInterval(t);
      }, 600);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
  window.addEventListener('load', durchgang);
})();
